export default __webpack_public_path__ + "static/media/sleep-green.04871242.svg";